import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { FunctionComponent } from 'react';
import { SystemTotalWidgetConfiguration } from './SystemTotalWidgetConfiguration';
import { useDashboardContext } from '@/modules/dashboards/contexts/DashboardContextProvider';
import { isNumber, startCase } from 'lodash-es';
import { SystemTotalType } from './system-total-type.enum';
import { useTranslation } from '@/lib';
import LabelValuesSelect from '@/modules/labels/components/LabelValuesSelect';

interface SystemTotalWidgetConfigurationFormProps {
  configuration: SystemTotalWidgetConfiguration;
  id: string;
}

const SystemTotalWidgetConfigurationForm: FunctionComponent<SystemTotalWidgetConfigurationFormProps> = ({ configuration, id }) => {
  const { updateWidgetConfiguration } = useDashboardContext();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-y-3">
      <TextField
        label={t('name')}
        value={configuration.title}
        onChange={(e) => {
          updateWidgetConfiguration<SystemTotalWidgetConfiguration>(id, {
            title: e.currentTarget.value,
          });
        }}
      />

      <FormControl>
        <InputLabel id="system-total-type-select-label">Total</InputLabel>
        <Select
          labelId="system-total-type-select-label"
          id="system-total-type-select"
          label={'Total'}
          defaultValue={configuration.systemTotalType}
          onChange={(e) => {
            updateWidgetConfiguration<SystemTotalWidgetConfiguration>(id, {
              title: '# ' + startCase(e.target.value as SystemTotalType),
              systemTotalType: e.target.value as SystemTotalType,
            });
          }}
        >
          {Object.values(SystemTotalType).map((totalType) => {
            if (isNumber(totalType)) {
              return;
            }
            return (
              <MenuItem key={totalType} value={totalType} className="first-letter:uppercase">
                {t(`dashboard.systemTotalWidget.${totalType}`)}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>

      <LabelValuesSelect
        selectedValues={configuration.labelValueIds ?? []}
        onChange={(values) => {
          updateWidgetConfiguration<SystemTotalWidgetConfiguration>(id, {
            labelValueIds: values,
          });
        }}
      />
    </div>
  );
};

export default SystemTotalWidgetConfigurationForm;
